import React from "react";

interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  id: string;
  name: string;
  cols?: number;
  rows?: number;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  value: string | number;
  required?: boolean;
  maxLength? : number;
}

const TextAreaField: React.FC<TextAreaProps> = ({
  id,
  name,
  cols,
  rows,
  value,
  onChange,
  maxLength,
  required = false,
}) => {
  return (
    <div className="relative">
      <textarea
        name={name}
        id={id}
        cols={cols}
        rows={rows}
        onChange={onChange}
        required={required}
        value={value}
        maxLength={maxLength}
        className="border border-[#ededed] p-[15px] w-full outline-none"
      />
    </div>
  );
};

export default TextAreaField;
